<template>
  <component :is="currentFaqComponent" />
</template>

<script>
import FaqGold from './faq/faqGold.vue'
import FaqPurple from './faq/faqPurple.vue'
import themeMixin from '@/mixins/themeMixin'

export default {
  components: {
    FaqGold,
    FaqPurple,
    SupportTiger: () => import('@/views/page/sup/tiger/supportTiger.vue')
  },
  mixins: [themeMixin],
  computed: {
    currentFaqComponent() {
      switch (this.currentTheme) {
        case 'theme_purple':
          return 'FaqPurple'
        case 'theme_tiger':
          return 'SupportTiger'
        case 'theme_gold':
        default:
          return 'FaqGold'
      }
    }
  }
}
</script>
